module.exports = __webpack_public_path__ + "img/play.e8d3a6a8.svg";